export const GET_DEALERLM_API_REQUEST = "GET_DEALERLM_API_REQUEST";
export const GET_DEALERLM_API_SUCCESS = "GET_DEALERLM_API_SUCCESS";
export const GET_DEALERLM_API_ERROR = "GET_DEALERLM_API_ERROR";

export const POST_DEALERLM_API_REQUEST = "POST_DEALERLM_API_REQUEST";
export const POST_DEALERLM_API_SUCCESS = "POST_DEALERLM_API_SUCCESS";
export const POST_DEALERLM_API_ERROR = "POST_DEALERLM_API_ERROR";

export const EDIT_LIVE_DEALER_LM_INFO = "EDIT_LIVE_DEALER_LM_INFO"